import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

export class ExcelHelper {
    constructor() { }

    static addHeaderRow(worksheet: any, header: string[]): void {
        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell: any, number: number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'D3D3D3' },
                bgColor: { argb: 'D3D3D3' }
            };
            cell.font = { bold: true };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            worksheet.getColumn(number).width = 20;
        });
    }

    static addSection(worksheet: any, title: string, data: any[], flatten: boolean = true): void {
        this.addSectionHeader(worksheet, title);
        data.forEach(d => {
            worksheet.addRow(flatten ? d.flat() : d);
        });
    }

    private static addSectionHeader(worksheet: any, title: string): void {
        let sectionHeader = worksheet.addRow([title]);
        sectionHeader.getCell(1).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'D3D3D3' },
            bgColor: { argb: 'D3D3D3' }
        };
        sectionHeader.getCell(1).font = { name: 'Calibri', size: 12, bold: true };
        sectionHeader.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        worksheet.getColumn(1).width = 25;
    }

    static saveWorkbook(workbook: Workbook, fileName: string): void {
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/octet-stream' });
            fs.saveAs(blob, fileName);
        });
    }

    static formatDateForFileName() : string {
        const date = new Date();
        return `${date.getFullYear()}${('0' + (date.getMonth() + 1)).slice(-2)}${('0' + date.getDate()).slice(-2)}`;
    }
}